import React from 'react';
import { motion } from 'framer-motion';
export function CostComparison() {
  const rows = [{
    sin: 'Llegás al primer año sin saber qué hito esperar',
    costo: 'Una oportunidad de desarrollo neurológico perdida para siempre'
  }, {
    sin: 'Buscás actividades en Google y encontrás info contradictoria',
    costo: 'Horas de angustia y confusión que podrían ser de juego'
  }, {
    sin: 'El berrinche te supera porque no entendés qué pasa',
    costo: 'Conflicto diario que desgasta el vínculo'
  }, {
    sin: 'No sabés si tu hijo necesita una consulta o no',
    costo: 'Consultas innecesarias o alertas que se pasan por alto'
  }, {
    sin: 'El jardín dice que "algo no cierra" y no sabés qué responder',
    costo: 'Angustia, culpa y reuniones sin solución'
  }, {
    sin: 'Cada etapa nueva te genera la misma incertidumbre',
    costo: 'Crianza reactiva en lugar de crianza con sistema'
  }, {
    sin: 'No tenés rutina de estimulación',
    costo: 'Los primeros 6 años pasan sin aprovechar la ventana crítica'
  }];
  return <section className="py-20 bg-black text-white" data-id="element-46">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-47">
        <div className="text-center mb-12" data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-49">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="overflow-x-auto pb-4 mb-12" data-id="element-50">
          <div className="min-w-[600px]" data-id="element-51">
            <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-52">
              <div className="font-bold text-sky-300 uppercase text-sm tracking-wider" data-id="element-53">
                Sin el Megapack
              </div>
              <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-54">
                Costo real
              </div>
            </div>

            <div className="space-y-2" data-id="element-55">
              {rows.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 bg-sky-950/60 rounded-xl p-4 items-center border border-sky-900" data-id="element-56">
                  <div className="text-sky-100 font-medium" data-id="element-57">{row.sin}</div>
                  <div className="text-red-300 font-medium" data-id="element-58">{row.costo}</div>
                </div>)}
            </div>
          </div>
          <p className="text-center text-sm text-sky-500 mt-4 md:hidden" data-id="element-59">
            ← Scroll to see full table →
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-sky-600 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-60">
          <p className="md:text-2xl font-medium text-sky-50 mb-4 text-[16px]" data-id="element-61">
            El próximo mes de vida de tu hijo puede encontrar un hogar
            diferente.
          </p>
          <p className="md:text-4xl font-black text-white text-[20px]" data-id="element-62">
            "La próxima semana, vas a saber exactamente qué hacer." 🌱🇦🇷
          </p>
        </motion.div>
      </div>
    </section>;
}